import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_REVENUE_DEPARTMENT_COLLECTION_NAME =
  "price-list-revenue-department";

export const useRxCollectionPriceListRevenueDepartment =
  (): RxCollection<PriceListRevenueDepartment> | null =>
    useRxCollection<PriceListRevenueDepartment>(
      RXDB_PRICE_LIST_REVENUE_DEPARTMENT_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<PriceListRevenueDepartment>>;
export type PriceListRevenueDepartmentQueryConstructor = UseRxData["1"];

const PRICE_LIST_REVENUE_DEPARTMENT_SCHEMA_LITERAL = {
  title: "price list revenue department schema",
  version: 1,
  description: "A revenue department referenced by prices",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    name: {
      type: "string",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "name", "meta"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(
  PRICE_LIST_REVENUE_DEPARTMENT_SCHEMA_LITERAL,
);

export type PriceListRevenueDepartment =
  ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const PRICE_LIST_REVENUE_DEPARTMENT_SCHEMA: RxJsonSchema<PriceListRevenueDepartment> =
  PRICE_LIST_REVENUE_DEPARTMENT_SCHEMA_LITERAL;
